// /src/pdf/core/pdfService.js
/* eslint-env browser */

// Ленивая (динамическая) загрузка pdfmake + шрифтов только в момент экспорта
let _pdfMakePromise = null;
async function getPdfMake() {
  if (!_pdfMakePromise) {
    _pdfMakePromise = (async () => {
      const pdfMod = await import("pdfmake/build/pdfmake.js");
      const pdfMake = pdfMod.default || pdfMod;

      const fontsModule = await import("pdfmake/build/vfs_fonts.js");
      const fonts = fontsModule.default || fontsModule;
      const vfs =
        (fonts && fonts.pdfMake && fonts.pdfMake.vfs) ||
        fonts?.vfs ||
        (fontsModule && fontsModule.pdfMake && fontsModule.pdfMake.vfs) ||
        fontsModule?.vfs ||
        (fonts && typeof fonts === "object" ? fonts : null);
      if (!vfs) {
        throw new Error("pdfmake virtual file system (vfs) not found");
      }
      pdfMake.vfs = vfs;
      return pdfMake;
    })();
  }
  return _pdfMakePromise;
}

/**
 * Экспорт через pdfmake
 * @param {object} docDefinition — схема pdfmake (content, styles, header, footer, pageMargins, etc.)
 * @param {string} filename — имя файла для скачивания
 */
export async function exportPdfMake(docDefinition, filename = "report.pdf") {
  let pdfMake;
  try {
    pdfMake = await getPdfMake();
  } catch (e) {
    console.error("Failed to load pdfmake:", e);
    alert("Не удалось загрузить движок экспорта PDF. Проверьте зависимости и обновите страницу.");
    throw e;
  }

  return new Promise((resolve, reject) => {
    try {
      pdfMake.createPdf(docDefinition).download(filename, () => resolve());
    } catch (e) {
      reject(e);
    }
  });
}

/**
 * Fallback: системная печать (для простых случаев)
 */
export async function exportPrint(triggerPrint) {
  if (typeof triggerPrint === "function") await triggerPrint();
  else window.print();
}

/**
 * Унифицированная точка входа.
 * @param {"pdfmake"|"print"} strategy
 * @param {object} payload — для "pdfmake": { docDefinition, filename }, для "print": { triggerPrint }
 */
export async function exportPdf(strategy, payload) {
  if (strategy === "pdfmake") {
    const { docDefinition, filename } = payload || {};
    if (!docDefinition) throw new Error("docDefinition is required for pdfmake strategy");
    return exportPdfMake(docDefinition, filename);
  }
  if (strategy === "print") {
    const { triggerPrint } = payload || {};
    return exportPrint(triggerPrint);
  }
  throw new Error(`Unknown PDF strategy: ${strategy}`);
}
